module.exports = path => () => import(`@/pages/${path}`)



// WEBPACK FOOTER //
// ./src/router/_import_production.js